import * as Yup from 'yup';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';

export type MultiContainerUpdateFormik = Record<string, string | null> & {
	customerRef: string | null;
};

export interface MultiContainerUpdateProps {
	legs: DispatchLeg[];
}

export const MultiContainerUpdateFormikValidationSchema = Yup.object<MultiContainerUpdateFormik>().shape({
	customerRef: Yup.string().required('Customer Reference is required.')
});
